import { Flex } from '@chakra-ui/react';
import { MlsListingWithListing } from '../../../MapSearch/ExploreContext';
import { HorizontalListingCard } from '../HorizontalListingCard';

interface GroupedListingCardProps {
  listings: MlsListingWithListing[];
  rightButton?: (listing: MlsListingWithListing) => React.ReactNode;
  bottomButton?: (listing: MlsListingWithListing) => React.ReactNode;
}

export const GroupedListingCard = ({
  listings,
  rightButton,
  bottomButton,
}: GroupedListingCardProps) => {
  return (
    <Flex
      bg="white"
      borderRadius="md"
      direction="column"
      maxHeight={{ base: '200px', md: '350px' }}
      overflowY="auto"
    >
      {listings.map((listing) => (
        <HorizontalListingCard
          key={listing.mlsListing.id}
          bottomButton={bottomButton?.(listing)}
          isHoverable={false}
          mlsListing={listing.mlsListing}
          rightButton={rightButton?.(listing)}
        />
      ))}
    </Flex>
  );
};
